"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartMetaToJSON = exports.CartMetaFromJSONTyped = exports.CartMetaFromJSON = exports.instanceOfCartMeta = void 0;
var runtime_1 = require("../runtime");
var CartMetaPartnership_1 = require("./CartMetaPartnership");
var CartMetaRereq_1 = require("./CartMetaRereq");
var ExomeMeta_1 = require("./ExomeMeta");
var FVTDetails_1 = require("./FVTDetails");
var Gene_1 = require("./Gene");
var PatientInformation_1 = require("./PatientInformation");
var TieredPanelValidation_1 = require("./TieredPanelValidation");
/**
 * Check if a given object implements the CartMeta interface.
 */
function instanceOfCartMeta(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCartMeta = instanceOfCartMeta;
function CartMetaFromJSON(json) {
    return CartMetaFromJSONTyped(json, false);
}
exports.CartMetaFromJSON = CartMetaFromJSON;
function CartMetaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'exome': !(0, runtime_1.exists)(json, 'exome') ? undefined : (0, ExomeMeta_1.ExomeMetaFromJSON)(json['exome']),
        'partnership': !(0, runtime_1.exists)(json, 'partnership') ? undefined : (0, CartMetaPartnership_1.CartMetaPartnershipFromJSON)(json['partnership']),
        'rereq': !(0, runtime_1.exists)(json, 'rereq') ? undefined : (0, CartMetaRereq_1.CartMetaRereqFromJSON)(json['rereq']),
        'fvtDetails': !(0, runtime_1.exists)(json, 'fvtDetails') ? undefined : (0, FVTDetails_1.FVTDetailsFromJSON)(json['fvtDetails']),
        'genesSuitableForRemainingGroups': !(0, runtime_1.exists)(json, 'genesSuitableForRemainingGroups') ? undefined : (json['genesSuitableForRemainingGroups'].map(Gene_1.GeneFromJSON)),
        'tieredPanelValidation': !(0, runtime_1.exists)(json, 'tieredPanelValidation') ? undefined : (0, TieredPanelValidation_1.TieredPanelValidationFromJSON)(json['tieredPanelValidation']),
        'helperMessageCode': !(0, runtime_1.exists)(json, 'helperMessageCode') ? undefined : json['helperMessageCode'],
        'helperMessageText': !(0, runtime_1.exists)(json, 'helperMessageText') ? undefined : json['helperMessageText'],
        'patientInformation': !(0, runtime_1.exists)(json, 'patientInformation') ? undefined : (0, PatientInformation_1.PatientInformationFromJSON)(json['patientInformation']),
    };
}
exports.CartMetaFromJSONTyped = CartMetaFromJSONTyped;
function CartMetaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'exome': (0, ExomeMeta_1.ExomeMetaToJSON)(value.exome),
        'partnership': (0, CartMetaPartnership_1.CartMetaPartnershipToJSON)(value.partnership),
        'rereq': (0, CartMetaRereq_1.CartMetaRereqToJSON)(value.rereq),
        'fvtDetails': (0, FVTDetails_1.FVTDetailsToJSON)(value.fvtDetails),
        'genesSuitableForRemainingGroups': value.genesSuitableForRemainingGroups === undefined ? undefined : (value.genesSuitableForRemainingGroups.map(Gene_1.GeneToJSON)),
        'tieredPanelValidation': (0, TieredPanelValidation_1.TieredPanelValidationToJSON)(value.tieredPanelValidation),
        'helperMessageCode': value.helperMessageCode,
        'helperMessageText': value.helperMessageText,
        'patientInformation': (0, PatientInformation_1.PatientInformationToJSON)(value.patientInformation),
    };
}
exports.CartMetaToJSON = CartMetaToJSON;
